import React, { useMemo, useContext, createContext } from 'react';
import { useMediaQueries } from 'seagull';

function useInnerMediaQuery(contextLoaded, disableMobile) {
  const {
    largerThanTablet,
    smallerThanTablet
  } = useMediaQueries();
  return useMemo(() => ({
    contextLoaded,
    isDesktop: disableMobile ? true : largerThanTablet,
    isMobile: disableMobile ? false : smallerThanTablet
  }), [contextLoaded, disableMobile, largerThanTablet, smallerThanTablet]);
}

const ResponsiveContext = /*#__PURE__*/createContext({
  contextLoaded: false,
  isMobile: false,
  isDesktop: false
});
export function ResponsiveProvider(_ref) {
  let {
    children,
    disableMobile = false
  } = _ref;
  return /*#__PURE__*/React.createElement(ResponsiveContext.Provider, {
    value: useInnerMediaQuery(true, disableMobile)
  }, children);
}
export function useResponsive() {
  const context = useContext(ResponsiveContext);
  const defaultContext = useInnerMediaQuery(false, false);
  return context.contextLoaded ? context : defaultContext;
}